/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{width:100%;min-width:40px;height:25px;padding:0 4px;text-align:center}.selected-record[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .selected-record[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{background-color:var(--bg-highlight-color)}.error-cell[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .error-cell[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{background-color:var(--qc-error-bg-color)}\n/*# sourceMappingURL=rc-cell.component.css.map*/"];
export { styles as styles };
